<% var component = new Anvil.models.components.TextFill(field) %>
<% if ('inline' in field && field.inline) { %>
<div anvil-component="<%- component.id %>" class="col-auto pr-0 py-1">
	<div class="text-fill">
		<div class="text-fill-area"><%- field.text.replace(/%SLOT%/gm, '<div class="text-fill-slot"></div>') %></div>
		<div class="text-fill-initial">
		<% for (let i = 0; i < field.options.length; i++) { %>
			<div value="<%= i %>" class="text-fill-item"><i class="fa fa-xs fa-grip-horizontal mr-2"></i><%= field.options[i] %></div>
		<% } %>
		</div>
	</div>
</div>
<% } else { %>
<div anvil-component="<%- component.id %>" class="form-group row">
	<div class="col-<%= ('label_width' in form.params) ? form.params.label_width : '4' %>">
		<label for="<%= form.name %>_<%= field.name %>" class="control-label"><%= field.title %></label>
	</div>
	<div class="col">
		<div class="text-fill-area"><%- field.text.replace(/%SLOT%/gm, '<div class="text-fill-slot"></div>') %></div>
		<div class="text-fill-initial">
		<% for (let i = 0; i < field.options.length; i++) { %>
			<div value="<%= i %>" class="text-fill-item"><i class="fa fa-xs fa-grip-horizontal mr-2"></i><%= field.options[i] %></div>
		<% } %>
		</div>
		<% if ('help' in field) { %><small class="form-text text-muted"><%- field.help %></small><% } %>
		<div class="invalid-feedback"></div>
	</div>
</div>
<% } %>
